import { render, staticRenderFns } from "./flockNotupload.vue?vue&type=template&id=3a3f1d07&scoped=true&"
import script from "./flockNotupload.vue?vue&type=script&lang=js&"
export * from "./flockNotupload.vue?vue&type=script&lang=js&"
import style1 from "./flockNotupload.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3f1d07",
  null
  
)

export default component.exports